import React from 'react';
import Framework from '@beardeddevops/react.framework';
import SidenavContent from './SidenavContent';
import onClickOutside from "react-onclickoutside";

//const FrameworkSideBar = Framework.Components.withRootState(Framework.Components.SideBar);

class Sidebar extends React.Component {

	render() {
		return (
			<Framework.Components.SideBar
				rootState={this.props.rootState}
				footerLink={"https://fflsoftwarepro.freshdesk.com/support/tickets/new"}
				clickOutside={false}
				arrows={this.props.rootState.arrow_setting}
				{...this.props}>
				<SidenavContent {...this.props} />
			</Framework.Components.SideBar>
		);
	}
}

export default Sidebar = Framework.Components.withRootState(Sidebar);
